import('./style');

class ConsoleJsonPrettyPrinter {
  constructor(jsonData) {
    this.jsonData = JSON.parse(jsonData);
  }

  replacer(match, pIndent, pKey, pVal, pEnd) {
    var key = '<span class=json-key>';
    var val = '<span class=json-value>';
    var str = '<span class=json-string>';
    var r = pIndent || '';
    if (pKey)
      r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ';
    if (pVal)
      r = r + (pVal[0] == '"' ? str : val) + pVal + '</span>';
    return r + (pEnd || '');
  }

  prettyPrint() {
    var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg;
    return JSON.stringify(this.jsonData, null, 3)
      .replace(/&/g, '&amp;').replace(/\\"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(jsonLine, this.replacer);
  }
}

$(document).ready(() => {
  $( "pre.console-json-pre" ).each((i, target) => {
    var printer = new ConsoleJsonPrettyPrinter($( target ).text());
    $( target ).html(printer.prettyPrint());
  });
});

